import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import * as legalActions from './reducer';

import './LegalMessage.css';

export class LegalMessageComponent extends Component {
  static get propTypes() {
    return {
      dismissed: PropTypes.bool,
      onDismiss: PropTypes.func
    };
  }

  render() {
    const { dismissed, onDismiss } = this.props;

    return (<div className={classnames('LegalMessage', { dismissed })}>
      <div className="content">
        <div className="actions">
          <button className="btn btn-primary" onClick={onDismiss}>Dismiss</button>
        </div>
        <div className="warning">
          RABOBANK: Unauthorised access or usage of this application is in breach of Rabobank&apos;s internal policies,
          is prohibited and may result in legal or disciplinary action being taken against you
        </div>
      </div>
    </div>);
  }
}

const mapStateToProps = state => ({
  dismissed: state.legal.dismissedWarning
});

const mapDispatchToProps = (dispatch) => {
  const {
    dismissWarning
  } = bindActionCreators(legalActions, dispatch);

  return {
    onDismiss: dismissWarning
  };
};

const LegalMessage = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(LegalMessageComponent));
export default LegalMessage;



// WEBPACK FOOTER //
// ./src/legal/LegalMessage.js